import PresentationVideoOfCreatorPage from "./PresentationVideoOfCreatorPage";

export default PresentationVideoOfCreatorPage;